import React from 'react';
export function ProblemSection() {
  const problems = [{
    emoji: '😩',
    title: 'Hours of Searching',
    text: 'Spending hours searching Instagram, YouTube, and Google for new drills.'
  }, {
    emoji: '😰',
    title: 'Doubting Your Drills',
    text: 'Wondering whether your session progression actually makes sense for your team.'
  }, {
    emoji: '📱',
    title: 'Screenshot Overload',
    text: "Saving hundreds of random drill screenshots you'll probably never actually use."
  }, {
    emoji: '😵',
    title: 'Mentally Drained',
    text: 'Feeling mentally drained before your training session even begins.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <div className="text-center mb-12" data-id="element-213">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-214">
            DOES THIS SOUND FAMILIAR?
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight mb-5 tracking-tight" data-id="element-215">
            You love coaching hockey, but{' '}
            <span className="italic text-pilates-rose" data-id="element-216">
              planning your training sessions
            </span>{' '}
            after work is becoming exhausting.
          </h2>
          <p className="text-lg text-pilates-slate max-w-2xl mx-auto" data-id="element-217">
            Every week you find yourself:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 mb-12" data-id="element-218">
          {problems.map((p, idx) => <div key={idx} className="bg-pilates-cream rounded-2xl p-7 border border-pilates-sage/20 hover:shadow-md hover:-translate-y-1 transition-all" data-id="element-219">
              <div className="text-4xl mb-3" data-id="element-220">{p.emoji}</div>
              <h3 className="font-display text-xl font-semibold text-pilates-dark mb-2" data-id="element-221">
                {p.title}
              </h3>
              <p className="text-pilates-slate leading-relaxed" data-id="element-222">{p.text}</p>
            </div>)}
        </div>

        <div className="bg-pilates-soft rounded-3xl p-8 sm:p-12 text-center border border-pilates-sage/20 shadow-sm" data-id="element-223">
          <p className="text-pilates-slate text-base sm:text-lg mb-6" data-id="element-224">
            And despite all that effort... You still walk onto the pitch
            wondering:
          </p>
          <div className="flex flex-col gap-3 mb-8 italic text-pilates-dark font-display text-xl sm:text-2xl" data-id="element-225">
            <p data-id="element-226">"Will this session flow smoothly?"</p>
            <p data-id="element-227">"Will my players stay engaged and intense?"</p>
            <p data-id="element-228">"Am I progressing them correctly for the season?"</p>
          </div>
          <p className="text-pilates-slate text-base sm:text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-229">
            <span className="font-semibold text-pilates-dark" data-id="element-230">
              You're not alone.
            </span>{' '}
            Most hockey coaches were taught how to demonstrate skills. Very few
            were taught how to structure complete, high-performance sessions
            efficiently. That's exactly why Hockey Ready was created.
          </p>
        </div>
      </div>
    </section>;
}